import { render, staticRenderFns } from "./split.vue?vue&type=template&id=02c2b555&scoped=true&"
import script from "./split.vue?vue&type=script&lang=js&"
export * from "./split.vue?vue&type=script&lang=js&"
import style0 from "./split.vue?vue&type=style&index=0&id=02c2b555&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2b555",
  null
  
)

export default component.exports